<template>
  <aw-cms-page-sidebar-wrapper
    :menu-items="menuItems"
    :selected-item="currentItem"
    @navigate="clickOnCareerMenu"
  >
    <template #content>
      <slot />
    </template>
  </aw-cms-page-sidebar-wrapper>
</template>

<script setup>
  import { computed } from 'vue';
  import { useNuxtApp, useRoute } from 'nuxt/app';
  import { useContentMenusStore } from '~~/common/stores/contentMenus';
  import { useContentMenu } from '~~/common/composables/useContentMenu';
  import { useCareerBreadcrumbs } from '~~/common/composables/useCareerBreadcrumbs';
  import { removeLocaleFromUrl } from '~~/common/utils/urlTransformation';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb.js';
  import AwCmsPageSidebarWrapper from '~~/common/components/Page/Content/Wrapper/Sidebar/AwCmsPageSidebarWrapper.vue';

  const { $awt } = useNuxtApp();
  const route = useRoute();
  const contentMenuStore = useContentMenusStore();
  const breadCrumbStore = useBreadcrumbStore();
  const { careerHomeBreadcrumb } = useCareerBreadcrumbs();

  const menuItems = computed(() => contentMenuStore.careerMenu.map((item, index) => ({
    id: `${item.to}-${index}`,
    name: item.label,
    link: item.to,
  })));

  const currentItem = computed(() => menuItems.value.find(item => isActive(item)));

  await useContentMenu('career-menu');

  const careerHome = contentMenuStore.careerMenu[0];
  if (careerHome) {
    const careerHomeToken = $awt('aw.pages.career.title');
    breadCrumbStore.setBreadcrumbs(breadCrumbStore.breadcrumbs.map((breadcrumb) => {
      if (breadcrumb.token === careerHomeToken) {
        breadcrumb.to = careerHome.to;
      }
      return breadcrumb;
    }));
  }

  function removeTrailingSlash (url) {
    return url.replace(/\/$/, '');
  }

  function isActive (menuItem) {
    return removeTrailingSlash(removeLocaleFromUrl(route.path)) === removeTrailingSlash(removeLocaleFromUrl(menuItem.link));
  }

  function clickOnCareerMenu (menuItem) {
    breadCrumbStore.setBreadcrumbs([
      {
        token: $awt('aw.common.category.home'),
        to: '/',
        disabled: false,
      },
      careerHomeBreadcrumb(true),
      {
        token: menuItem.name,
        to: menuItem.link,
        disabled: true,
      },
    ]);
  }
</script>
